import DetailsList from './DetailsList';
import Header from './Header';
import Main from './Main';
import Root, { DrawerTestId } from './Root';
import Section from './Section';
import Summary from './Summary';
import { IDrawerHeaderProps, IDrawerProps } from './types';

export const Drawer = Object.assign(Root, {
  Header,
  Main,
  Summary,
  DetailsList,
  Section,
});
export type { IDrawerProps, IDrawerHeaderProps };
export { DrawerTestId };
